module.exports = __webpack_public_path__ + "static/procesKreacjaMobile@x1-3d46d49e59c755fd5d0a2e322fe728e7.png";